export const PAGE_TITLES = {
  HOMEPAGE: 'Home  - KiwiWrite Math',
  CONTACT_US: 'Contact Us - KiwiWrite',
  TERMS_AND_CONDITION: 'Terms - KiwiWrite',
  PRIVACY_POLICY: 'Privacy - KiwiWrite',

  USER_LOGIN: 'Login - KiwiWrite Math',
  USER_SIGNUP: 'Sign-up - KiwiWrite Math',
  USER_FORGOT_PASSWORD: 'Forgot Password - KiwiWrite',
  USER_VERIFY_EMAIL: 'Verify Email- KiwiWrite',
  USER_RESET_PASSWORD: 'Reset Password - KiwiWrite',

  STUDENT_HOME: 'Welcome - KiwiWrite',
  STUDENT_CHOOSE_MATH_LEVEL: 'Choose Level - KiwiWrite',
  STUDENT_PLAN_SELECTION: 'Select plan - KiwiWrite',
  STUDENT_PLAN_SELECTION_SUCCESS: 'Plan selection successful - KiwiWrite',
  STUDENT_PLAN_SELECTION_FAILURE: 'Plan selection failed - KiwiWrite',
  STUDENT_OPEN_FILES: 'Open Files - KiwiWrite',
  STUDENT_PRINT_CANVAS: 'Print - KiwiWrite',
  STUDENT_ADD_PAYMENT_METHOD_SUCCESS: 'Add Payment Success - KiwiWrite',
  STUDENT_ADD_PAYMENT_METHOD_FAILURE: 'Add Payment Failure - KiwiWrite',
  STUDENT_INVITATION: 'Teacher Invitation - KiwiWrite',

  SCHOOL_SIGNUP: 'School Admin Sign-up - KiwiWrite',
  SCHOOL_DASHBOARD: 'School Admin - KiwiWrite',

  MANAGE_STUDENTS: 'Manage Students - KiwiWrite',

  ADMIN_LOGIN: 'Admin Login - Kiwiwrite',
  ADMIN_USER_MANAGEMENT: 'Admin - User Management',
  ADMIN_SCHOOL_MANAGEMENT: 'Admin - School Management',
  ADMIN_SUBSCRIPTION_MANAGEMENT: 'Admin - Extend Subscription',
  ADMIN_CREATE_SITE_ADMIN: 'Admin - Create Site Admin',
  ADMIN_DOMAIN_REQUEST_MANAGEMENT: 'Admin - Domain Request Management',
  ADMIN_SINGLE_ACCESS_CODE: 'Admin - Single Access Code',
};
